import { render } from "./Loan_Disbursements.vue?vue&type=template&id=0e9a1c4e"
import script from "./Loan_Disbursements.vue?vue&type=script&lang=js"
export * from "./Loan_Disbursements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__